// src/utils/maputils.js
// Fallback coordinates if geocoding fails
const defaultCoords = { lat: 45.4642, lng: 9.1900 }; // Milan

// Cache to store fetched coordinates
const coordsCache = {};

// Load cached coordinates from localStorage on startup
if (typeof window !== 'undefined') {
  const cached = localStorage.getItem('coordsCache');
  if (cached) {
    Object.assign(coordsCache, JSON.parse(cached));
  }
}

// Save coordinates to localStorage
const saveToCache = (key, coords) => {
  coordsCache[key] = coords;
  if (typeof window !== 'undefined') {
    localStorage.setItem('coordsCache', JSON.stringify(coordsCache));
  }
};

// Delay function to throttle API requests
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Fetch coordinates using Google Maps Geocoding API
export async function getCityCoords(city, country, index = 0, street = "") {
  if (!city) {
    console.error(`Invalid city: city=${city}, country=${country}, street=${street}`);
    return defaultCoords;
  }

  // Build the address string
  let addressParts = [];
  if (street) addressParts.push(street);
  if (city) addressParts.push(city);
  if (country) addressParts.push(country);
  const key = addressParts.join(", ");

  if (coordsCache[key]) {
    return coordsCache[key];
  }

  try {
    await delay(index * 100);

    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(key)}&key=AIzaSyCcIffoH53mi-1keO7yQ7yroXiRDoCHmr4`
    );
    const data = await response.json();
    if (data.status === 'OK' && data.results.length > 0) {
      const { lat, lng } = data.results[0].geometry.location;
      const coords = { lat, lng };
      saveToCache(key, coords);
      return coords;
    } else {
      console.error(`Geocoding failed for ${key}: ${data.status}`);
      return defaultCoords;
    }
  } catch (error) {
    console.error(`Error fetching coordinates for ${key}:`, error);
    return defaultCoords;
  }
}